import React from "react";
import cn from 'classnames'

import {Number} from '../utils'
import ReactDOM from "react-dom";
import ScoreTableBtn from "../scoreTableBtn";
import {withStore} from "game_play/utils/store";

const $scoreTableBtn = document.querySelector('#react-score-table-btn');

class ScoreTable extends React.Component {

  $legsRef = React.createRef()

  renderShots(ss) {
    if (ss.sectors) {
      return ss.sectors.map((shot, i) =>
        <span key={i} className="table__shot-sector">{shot ? <Number value={shot[0] * shot[1]}/> : null}</span>
      )
    } else {
      return ss.score !== undefined ? <Number value={ss.score}/> : null
    }
  }

  renderLeg(leg, i, legs, scores, winner_number) {
    const {Game} = this.props
    const {player_1, player_2} = Game.get('game')
    const slice_legs = legs.slice(0, i + 1)
    const [score_1, score_2] = Game.calculateTotalScore(slice_legs)
    const first = Game.calculateFirst(slice_legs)
    const offsetSector = Game.offsetSectors(i)
    return (
      <table key={i} className="table score_table">
        <thead>
        <tr>
          <th width="45%" className={cn('p1_name text__left', {
            'score_table__red-circle': first === 0,
            'score_table__winner': winner_number === 1,
          })}>{player_1.name}</th>
          <th className="7%">
            <div className="score_table__score">
              <span><Number value={score_1}/></span>
              <span style={{padding: '0 10px'}}>-</span>
              <span><Number value={score_2}/></span>
            </div>
          </th>
          <th width="45%" className={cn('p2_name text__right', {
            'score_table__red-circle': first === 1,
            'score_table__winner': winner_number === 2,
          })}>{player_2.name}</th>
        </tr>
        </thead>
        <tbody>
        <tr className="score_table__subheader">
          {/* <td>{gettext('Счет')}</td> */}
          <td>Scored</td>
          <td>{gettext('Сектор')}</td>
          <td>Scored</td>
        </tr>
        {leg.map(([ss1, ss2], j) => {
          const render_index = j + 1 + offsetSector
          return (
            <tr key={j}>
              <td className="..table__shot-sectors">
                {this.renderShots(ss1)}
              </td>
              <td>{render_index === 21 ? 'Bull' : render_index}</td>
              <td className="..table__shot-sectors">
                {this.renderShots(ss2)}
              </td>
            </tr>
          )
        })}
        <tr>
          <td className='table__total_score'>{scores[0]}</td>
          <td>{gettext('Итог')}</td>
          <td className='table__total_score'>{scores[1]}</td>
        </tr>
        </tbody>
      </table>
    );
  }

  render() {
    const {Game} = this.props
    const legs = Game.get('game').data;

    return (
      <>
        {ReactDOM.createPortal(
          <ScoreTableBtn table={this.$legsRef} root={$scoreTableBtn}/>,
          $scoreTableBtn
        )}
        <div className="container-spacer match__rounds hide" ref={this.$legsRef}>
          <div className="container-body">
            <h2 className="sub-heading -l">{gettext('Леги')}</h2>
            {legs.map((leg, i) => {
              const winner_number = Game.getWinnerNumberByLeg(leg)
              const scores = Game.calculateScore(leg)
              return this.renderLeg(leg, i, legs, scores, winner_number)
            })}
          </div>
        </div>
      </>
    );
  }
}

export default withStore(ScoreTable)